export default __webpack_public_path__ + "static/media/ico_pass_on.6ff12e28.svg";